var heading_default = {
  "fontElementMap": "_5Ncux",
  "elementSpacing": "dKj9-",
  "headerOne": "MeFAM dKj9-",
  "headerTwo": "E0KQ4 dKj9-",
  "headerThree": "sgkaM dKj9-",
  "headerFour": "fQrCL dKj9-",
  "headerFive": "IovRB dKj9-",
  "headerSix": "TeCTZ dKj9-",
  "child": "_36JOx"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
